import { Avatar, Button } from "antd";
import moment from "moment";
import { useAppSelector } from "../../../../../../app/store";
import AvatarImage from "../../../../../../assets/images/avatar.svg";
import useModal from "../../../../../../hooks/useModal";
import AddNewCCModal from "./AddNewCCModal";
import { TabProps } from "./TicketDetailsTabs";

const TicketCCTab = ({ ticketDetails }: TabProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const { open, handleOpen, handleClose } = useModal();
  const { id, ccs, status, raised_by_dept_id } = ticketDetails || {};

  // Todo: Need to update add CC condition
  const canAddCC =
    status !== "cancel" &&
    status !== "completed" &&
    user?.department_id === raised_by_dept_id;

  return (
    <div className="">
      {open.type === "ADD" && (
        <AddNewCCModal id={id} open={open.open} handleClose={handleClose} />
      )}

      <div
        className={`${
          canAddCC ? "h-[calc(100vh_-_440px)]" : "h-[calc(100vh_-_390px)]"
        } w-full overflow-auto`}
      >
        {ccs?.map((item: any) => (
          <div
            className="p-4 bg-white shadow rounded-md max-w-md mx-auto mb-2"
            key={item?.id}
          >
            <div className="flex items-start space-x-3 ">
              <Avatar
                src={item?.employee?.personalInfo?.pro_pic || AvatarImage}
                size={40}
                className="object-cover"
              />
              <div className="w-full flex-1">
                <div className="flex gap-4 text-base">
                  <span className="font-semibold">
                    {item?.employee?.officialInfo?.name}
                  </span>
                </div>

                <p className="text-[#3D4A5C] text-base">
                  {moment(item?.created_at).fromNow()}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {!!canAddCC && (
        <div className="mt-4">
          <Button
            type="default"
            className="button-primary-light !w-full h-10"
            block
            onClick={() => handleOpen({ type: "ADD" })}
          >
            Add New CC
          </Button>
        </div>
      )}
    </div>
  );
};

export default TicketCCTab;
